import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Loading from "../../../../../pages/Loading/Loading";

const MenuBafar = lazy(() =>
  import("../../../../../features/print-tags").then((module) => ({
    default: module.MenuBafar,
  }))
);

export const Route = createFileRoute(
  "/$lang/_authenticated/menu-print-tags/bafar"
)({
  component: () => (
    <Suspense fallback={<Loading />}>
      <MenuBafar />
    </Suspense>
  ),
});
